import PropTypes from 'prop-types'
import { get } from 'lodash'

import createForm from '~/utils/create-form'

export const address = {
  address: PropTypes.string,
  address_line_2: PropTypes.string,
  city: PropTypes.string,
  postal_code: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string,
};

export const contact = {
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  company_billing: PropTypes.bool,
  company: PropTypes.string,
  subscribe_to_newsletter: PropTypes.bool,
  address: address
};

export const propTypes = {
  ...contact,
  address: PropTypes.shape(address),
};

export const defaults = {
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  company_billing: false,
  company: '',
  subscribe_to_newsletter: false,
  address: {
    address: '',
    address_line_2: '',
    city: '',
    postal_code: '',
    state: '',
    country: 'EE',
  },
};

export const fillWithDefaults = (contact, outerDefaults = {}) => {
  return {
    ...defaults,
    ...outerDefaults,
    ...contact,
    address: {
      ...defaults.address,
      ...(outerDefaults.address || {}),
      ...(contact.address || {}),
      country: get(contact, 'address.country.code', defaults.address.country)
    }
  }
}

export default () => {
  return createForm({
    propTypes: propTypes,

    defaults,
  })
}